document.addEventListener("DOMContentLoaded", function() {
    let budgetTotal = 0;

    // Überprüfe den Warenkorb und berechne das Budget
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            data.items.forEach(item => {
                // Überprüfe, ob das Budget als Produkt im Warenkorb ist
                if (item.product_title === "_budget") { // Budget-Produkt anhand des Titels
                    budgetTotal += item.final_line_price / 100; // Preis des Budgets in Cent
                }
            });

            // Wenn Budget vorhanden ist, füge es als separates Produkt zum Warenkorb hinzu
            if (budgetTotal > 0) {
                const budgetProductInCart = data.items.some(item => item.product_title === "_budget");

                if (!budgetProductInCart) {
                    // Füge das Budget als Produkt hinzu (Ersetze _budget mit deinem Budget-Produkt)
                    const body = JSON.stringify({
                        items: [
                            {
                                id: '_budget', // Budget-Produkt wird durch _budget referenziert
                                quantity: 1,
                                properties: {
                                    "Budget": budgetTotal.toString(), // Beispiel für eine Budget-Eigenschaft
                                }
                            }
                        ]
                    });

                    // Budget als neues Produkt in den Warenkorb hinzufügen
                    fetch('/cart/add.js', {
                        method: 'POST',
                        body: body,
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(response => response.json())
                    .then(cart => {
                        console.log('Budget als Produkt hinzugefügt', cart);
                        // Optional: Aktualisiere den Warenkorb im UI
                        updateCartUI();
                    })
                    .catch(error => {
                        console.error('Fehler beim Hinzufügen des Budgets zum Warenkorb:', error);
                    });
                }
            }
        });
});




function updateCartUI() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            // Hier kannst du den DOM des Warenkorbs aktualisieren
            const cartContainer = document.querySelector('.cart-items'); // Deine Zielcontainer für die Warenkorb-Daten

            let cartHTML = '';
            data.items.forEach(item => {
                // Beispiel für die Darstellung des Produkts
                cartHTML += `
                    <div class="cart-item">
                        <p>${item.product_title}</p>
                        <p>${item.quantity}</p>
                        <p>${(item.final_line_price / 100).toFixed(2)} €</p>
                    </div>
                `;
            });

            // Wenn das Budget im Warenkorb ist, zeige es als separates Element
            if (data.items.some(item => item.product_title === "_budget")) {
                cartHTML += `
                    <div class="cart-item budget-item">
                        <p>Zusatzbudget</p>
                        <p>1</p>
                        <p>${budgetTotal.toFixed(2)} €</p>
                    </div>
                `;
            }

            // Setze den HTML-Inhalt des Warenkorb-Containers
            cartContainer.innerHTML = cartHTML;
        })
        .catch(error => console.error('Fehler beim Abrufen des Warenkorbs:', error));
}
